export function waitUntilPageLoaded() {
    return new Promise<void>(resolve => {
        if (document.readyState === 'complete') {
            resolve();
        }

        window.addEventListener('load', () => resolve(), { once: true });
    });
}
